import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Helmet} from 'rnd-helmet';
import axios from 'axios';
import {injectIntl} from 'react-intl';

const Homepage = ({staticContext, match, intl}) => {
  let initialData = {};
  if (staticContext && staticContext.data) {
    initialData = staticContext.data;
  }

  // eslint-disable-next-line
  const [state, setState] = useState(initialData);
  useEffect(() => {
    if (window.__ROUTE_DATA__) {
      setState(window.__ROUTE_DATA__);
      delete window.__ROUTE_DATA__;
    } else {
      axios.post('/api/search/get-callback', {
        callback: '@Callbacks/apiTestResults',
        currentRoute: {...match, ...{routeName: 'homepage'}},
        data: {},
      }).then((response) => {
        setState(response);
      }).catch((error) => {});
    }
  }, [match]);

  // Load the routes for the specific country.
  const routes = require(`../../../config/client.routes.json`);

  const lang = intl.locale ? intl.locale : process.env.REACT_APP_DEFAULT_LANGUAGE;

  const clientRoutesMarkup = [];
  for (const routeName in routes[lang]) {
    if (routes[lang].hasOwnProperty(routeName) && routes[lang][routeName].hasOwnProperty('url')) {
      const route = routes[lang][routeName];
      clientRoutesMarkup.push(
          <div key={`route-${lang}-${routeName}`}>
            <Link to={route.url}>{routeName}</Link>
          </div>,
      );
    }
  }

  const apiRoutesMarkup = [];
  if (process.env.REACT_APP_ISDEV) {
    const apiRoutes = require(`../../../config/api.routes`);
    for (const routeName in apiRoutes) {
      if (apiRoutes.hasOwnProperty(routeName)) {
        apiRoutesMarkup.push(
            <div key={`server-route-${routeName}`}>
              <a href={apiRoutes[routeName].url}>{routeName}</a> - {apiRoutes[routeName].url}
            </div>,
        );
      }
    }
  }

  return (
    <div>
      <Helmet>
        <header className="header header--text bg-brand--dark-blue"/>
      </Helmet>
      <div>
        <h2>React routes</h2>
        {clientRoutesMarkup}
      </div>
      {
        process.env.REACT_APP_ISDEV ?
          <div>
            <h2>API routes</h2>
            {apiRoutesMarkup}
          </div> : null
      }
    </div>
  );
};

export default injectIntl(Homepage);
